<template>
  <router-link :to="{ name: 'leads.overview', params: { lead_id: lead.id } }">
    <div class="row">
      <div class="col-12 col-lg-3 flex-column align-items-stretch justify-content-center">
        <p class="text-truncate mb-1">
          <span class="strong">{{ lead.first_name }} {{ lead.surname }}</span>
        </p>
        <p class="text-truncate small text-muted mb-0">
          <template v-if="lead.company">{{ lead.company }}<br/></template>
          {{ lead.email }}
          <template v-if="lead.phone"><br/>{{ lead.phone }}</template>
          <template v-if="lead.mobile"><br/>{{ lead.mobile }}</template>
        </p>
      </div>
      <div class="col-12 col-lg">
        <pre class="lead-message mb-0">{{ lead.message }}</pre>
      </div>
      <div class="col-6 col-lg-auto lead-col-assigned align-items-center">
        <template v-if="lead.assigned">
          <c-avatar small :name="lead.assigned.name" :url="avatarUrl(lead.assigned.id)" class="me-2" />
          <span class="text-truncate">{{ lead.assigned.name }}</span>
        </template>
        <span v-else class="text-muted">Unassigned</span>
      </div>
      <div class="col-6 col-lg-auto lead-col-dates flex-column align-items-stretch justify-content-center">
        <p class="mb-0">
          <span class="data-label">Received</span>
          {{ lead.created_at | moment('DD/MM/YYYY') }}
        </p>
        <p class="mb-0">
          <span class="data-label">Updated</span>
          {{ lead.updated_at | moment('DD/MM/YYYY') }}
        </p>
      </div>
      <div class="col-6 col-lg-auto lead-col-status justify-content-lg-end">
        <div class="dropdown">
          <button
            type="button"
            class="btn btn-link p-0 dropdown-toggle"
            v-dropdown
            aria-haspopup="true"
            aria-expanded="false"
            @click.prevent
          >
            <span class="status" :class="stageClass(lead.stage)">{{ stageName(lead.stage) }}</span>
          </button>
          <div class="dropdown-menu dropdown-menu-end">
            <a
              v-for="stage in stages"
              :key="stage.key"
              class="dropdown-item"
              href="#"
              @click.prevent="updateStage(stage.key)"
            >{{ stage.name }}</a>
          </div>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
import { mapActions } from 'vuex'
import { stages, stageName, stageClass } from './stages'

export default {
  props: {
    lead: {
      required: true,
      type: Object
    }
  },

  data () {
    return {
      stages
    }
  },

  methods: {
    ...mapActions('lead', { updateLead: 'updateListObject' }),

    stageName,
    stageClass,

    avatarUrl (id) {
      return process.env.VUE_APP_API_URL + '/user/' + id + '/avatar'
    },

    async updateStage (stage) {
      await this.updateLead({ id: this.lead.id, payload: { stage } })

      this.$emit('stage-changed', this.lead)
    }
  }
}
</script>

<style scoped>
.lead-message {
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  padding: 0.5rem 0.75rem;
  font-family: inherit;
  font-size: 0.875rem;
  white-space: pre-wrap;
  word-break: break-word;
  background-color: var(--bs-tertiary-bg, #f8f9fa);
  border-radius: var(--bs-border-radius, 0.375rem);
}
</style>
